import React, { useCallback, useContext, useEffect, useState } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { BasicScrollView } from "@/components/BasicScrollView";
import { RelativePathString, useLocalSearchParams, useRouter } from 'expo-router';
import Head from 'expo-router/head';
import * as AppUtils from '@/utilities/AppUtils';
import * as AppUtilities from "@/utilities/AppUtilities";
import Footer from '@/components/Footer';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { CustomText } from '@/components/CustomText';
import { AppText } from '@/components/AppText';
import * as AppConsts from '@/utilities/AppConsts';
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    alignItems: 'center',
    backgroundColor: 'transparent',
    gap: 20,
  },
  contentWrapper: {
    padding: 20,
    gap: 20,
  },
});

export default function Join() {
  return (
    <BasicScrollView center={true}>
      <Meta title={"Payment denied"} />
      <AppText>Please go back to check your payment details and try again</AppText>
      <Footer />
    </BasicScrollView>
  );
}
